// src/components/Footer.js

import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLocationDot, faPhone, faEnvelope, faMobile } from '@fortawesome/free-solid-svg-icons';
import './Footer.css'; // Import the CSS for the footer
import { useTranslation } from 'react-i18next';
import useLocalizedPath from '../../hooks/useLocalizedPath';

const Footer = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const localizedPath = useLocalizedPath();

  // Scroll to top on internal link click
  const handleNavigation = (path) => {
    navigate(localizedPath(path));
    window.scrollTo(0, 0); // Scroll to the top of the page
  };

  // Social media handlers
  const openFacebook = () => {
    window.open('https://www.facebook.com/krlkimya', '_blank');
  };

  const openInstagram = () => {
    window.open('https://www.instagram.com/krlkimya', '_blank');
  };

  const openLinkedIn = () => {
    window.open('https://www.linkedin.com/company/krl-kimya', '_blank');
  };

  return (
    <footer className="footer" data-aos="fade-up">
      <Container fluid className="text-light">
        <Row>
          <Col md={12} className="footer-section contact">
            <h5 onClick={() => handleNavigation('/contact')}>{t('contact.title2')}</h5>
            <address>
              <p>
                <FontAwesomeIcon icon={faLocationDot} />
                <a
                  href="https://maps.app.goo.gl/Jk8ef54a4V83cGyB8"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {t('header.contact.address')}
                </a>
              </p>
              <p>
                <FontAwesomeIcon icon={faPhone} />
                <a href="tel:+902165049470"> +90 216 504 94 70</a>
              </p>
              <p>
                <FontAwesomeIcon icon={faPhone} />
                <a href="tel:+902165049479"> +90 216 504 94 79</a>
              </p>
              <p>
                <FontAwesomeIcon icon={faMobile} />
                <a href="tel:+905495754408"> +90 549 575 44 08</a>
              </p>
              <p>
                <FontAwesomeIcon icon={faEnvelope} />
                <a href="mailto:info@krlkimya.com">info@krlkimya.com</a>
              </p>
            </address>
          </Col>
        </Row>
        <Row className="footer-section-wrapper">
          <Col xs={12} md={4} className="footer-section">
            <h5>{t('footer.corporate')}</h5>
            <ul>
              <li>
                <button className="nav-link" onClick={() => handleNavigation('/about')}>{t('header.navigation.about')}</button>
              </li>
              <li>
                <button className="nav-link" onClick={() => handleNavigation('/catalog')}>{t('header.navigation.catalogs')}</button>
              </li>
              <li>
                <button className="nav-link" onClick={() => handleNavigation('/documents')}>{t('header.navigation.documents')}</button>
              </li>
              <li>
                <button className="nav-link" onClick={() => handleNavigation('/contact')}>{t('header.demo_button')}</button>
              </li>
            </ul>
          </Col>
          <Col xs={12} md={4} className="footer-section">
            <h5>{t('header.navigation.products')}</h5>
            <ul>
              <li>
                <button className="nav-link" onClick={() => handleNavigation('/products?category=mutfak')}>{t('products.categories.kitchen')}</button>
              </li>
              <li>
                <button className="nav-link" onClick={() => handleNavigation('/products?category=bina-bakimi')}>{t('products.categories.building_maintenance')}</button>
              </li>
              <li>
                <button className="nav-link" onClick={() => handleNavigation('/products?category=kisisel-hijyen')}>{t('products.categories.personal_hygiene')}</button>
              </li>
              <li>
                <button className="nav-link" onClick={() => handleNavigation('/products?category=camasir')}>{t('products.categories.laundry')}</button>
              </li>
              <li>
                <button className="nav-link" onClick={() => handleNavigation('/products?category=gida-hijyeni')}>
                 {t('products.categories.food_hygiene')}
                </button>
              </li>
              <li>
                <button className="nav-link" onClick={() => handleNavigation('/products?category=dezenfektanlar-ve-antiseptikler')}>{t('products.categories.disinfectants')}</button>
              </li>
              <li>
                <button className="nav-link" onClick={() => handleNavigation('/products?category=ozel-urunler')}>
                  {t('products.categories.special_products')}
                </button>
              </li>
              <li>
                <button className="nav-link" onClick={() => handleNavigation('/products?category=endustriyel-kimya')}>
                  {t('products.categories.industrial_chemistry')}
                </button>
              </li>
              
            </ul>
          </Col>
          <Col xs={12} md={4} className="footer-section">
            <h5>{t('footer.social_media')}</h5>
            <ul>
              <li>
                <a href="https://www.facebook.com/krlkimya" target="_blank" rel="noopener noreferrer" onClick={openFacebook}>Facebook</a>
              </li>
              <li>
                <a href="https://www.instagram.com/krlkimya" target="_blank" rel="noopener noreferrer" onClick={openInstagram}>Instagram</a>
              </li>
              <li>
                <a href="https://www.linkedin.com/company/krl-kimya" target="_blank" rel="noopener noreferrer" onClick={openLinkedIn}>LinkedIn</a>
              </li>
            </ul>
          </Col>
        </Row>
        <Row className="footer-bottom">
          <Col md={12} className="text-center">
            <p>{t('footer.copyright')}</p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
